<template>
	<div class="parent">
		<div class="scroll">
			<div class="centered">
				<input style="width:300px; height:30px; margin-right:10px;"></input>
				<b>Limit</b>
				<input v-model="limit" @keydown.enter="search()" style="width:60px"></input>
				<!--<input type="checkbox" style="width:30px; height:30px; padding:10px;" v-model="full_search">Show all documents</input>-->
			</div>
			<div class="centered" v-if="column_data.length>0 && column_data[0].length>0">
				<div v-if="is_document==true" class="centered">
					<div v-for="(data, index) in column_data" class="grid-item">
						<document
						:id="index"
						:dir="'doc_'+data[0]+'.jpg'"
						:doc_id="data[0]"
						v-on:input="select"
						style="width:350px; height:auto;"
						></document>
					</div>
				</div>
				<div v-else class="centered">
					<div v-for="(data, index) in column_data" class="grid-item">
						<vesselpic
							:dir="path+parseInt(data[0])+'.jpg'"
							:vesselpic_id="parseInt(data[0])"
							style="width:350px; height:auto;">
						</vesselpic>
					</div>
				</div>
			</div>
			<div v-else>
				<br/>
				<b>{{empty}}</b>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        id: Number,
		term:{
			type: String,
			required: false,
			default: '',
		},
		is_document:{
			type: Boolean,
			required: false,
			default: true,
		},
		path:{
			type: String,
			required: false,
			default: '',
		},
		empty:{
			type:String,
			required:false,
			default:"Empty"
		}
    },
	data() {
		return {
			perms:[],
			column_names: [],
			column_data:[],
			full_search:false,
			limit:10,
		}
	},
	async created (){

		var getLimit = api.getCookie("limit_"+this.id)
		if(getLimit!=null && getLimit!=undefined) { this.limit = getLimit }

		this.perms = api.getPerms();
		this.search();
	},
	methods:{
		async search (){

			document.cookie="limit_"+this.id+"="+this.limit+";";

			api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.id,
						fullsearch:this.full_search,
						limit:this.limit,
						data:[
							this.term,
	                    ],
					}
                }
            ).then((res) => {
	            this.column_names = res.data.data.column_names;
				this.column_data = res.data.data.column_data;
	        });
		},
		async select(index){
			if(this.perms.includes('17')){
				router.push('/0502?q='+this.column_data[index][0]);
			}
		}
	},
	watch:{
		full_search(){
			this.search();
		}
	}
}
</script>

<style scoped>
.grid-item{
	padding: 10px;
	font-size: 30px;
	text-align: center;
	width:400px;
	height:550px;
}

.centered{
	display:flex;
	flex-wrap: wrap;
	justify-content:center;
	margin:10px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout_5.vue